import React, { memo, ReactNode } from 'react';

import { cn } from 'utils';

interface IGroupInputInput {
	label?: string;
	containerClassName?: string;
	required?: boolean;
	horizontal?: boolean;
	value?: string;
	groupClassName?: string;
	children?: ReactNode;
	labelClassName?: string;
	subLabel?: string;
}
const GroupInput: React.FC<IGroupInputInput> = ({
	label,
	containerClassName = '',
	required = false,
	horizontal = true,
	children,
	groupClassName,
	labelClassName = '',
	subLabel,
}) => {
	return (
		<div
			className={cn(
				`flex gap-2`,
				horizontal ? 'items-center' : 'flex-col',
				containerClassName
			)}
		>
			{label && (
				<label
					className={cn(
						'text-[13px] font-medium text-font2',
						horizontal && 'min-w-[110px]',
						labelClassName
					)}
				>
					{label} {required && <span className="text-red6 ml-1">*</span>}
					{subLabel}
				</label>
			)}
			<div className={cn('flex flex-1 items-center gap-2', groupClassName)}>
				{children}
			</div>
		</div>
	);
};

export default memo(GroupInput);
